'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropSourceWrapper = require('./components/DragDropSourceWrapper.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropSourceWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drag-drop/lib/components/drag-drop-source-wrapper/index.js
// module id = 1185
// module chunks = 0